/**
 * 🛰️ SEC_00_DB_PAYLOAD
 * ----------------------------------------------------------------------------
 * Standards: 
 * - Two-way communication: SEND (POST) and GET (Retrieval).
 * - Empty X-INTENT forces Doorman.cs to route via Postman.
 * - Injects siteUserGuid/sessionID into POST bodies for .NET DTO alignment.
 */

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/**
 * 🛡️ Core DB Interrogation Engine
 */
export const dbPayload = async (endpoint, method = "GET", siteKey, body = {}, intent = "") => {

  // 1. Extract session assets (GUID, SessionID) already in storage
  const sessionId = sessionStorage.getItem('SEC_SESSION_ID');
  const userGuid = sessionStorage.getItem('SEC_USER_GUID');

  // 2. Build headers - empty X-INTENT triggers the Postman passthrough to
  // nrgCore; a named intent (e.g. "AddressValidate") routes Doorman.cs to a
  // dedicated branch instead (Dogma, XBRL, utility Lambdas, etc.)
  const headers = {
    "Content-Type": "application/json",
    "SITE-KEY": siteKey,
    "X-INTENT": intent,
    "Authorization": `Bearer ${sessionId}`,
    "X-SEC-USER-GUID": userGuid,
    "X-SEC-SESSION-ID": sessionId,
    "X-TIMESTAMP": Math.floor(Date.now() / 1000).toString(),
  };

  // 3. DIRECTIONAL LOGIC
  let fetchOptions = { method, headers };

  if (method.toUpperCase() === "POST") {
    // SEND DIRECTION: Braid session markers into the DTO for .NET
    const enhancedBody = {
      ...body,
      siteUserGuid: userGuid,
      sessionID: sessionId
    };
    fetchOptions.body = JSON.stringify(enhancedBody);
  }

  // 4. EXECUTE HANDSHAKE
  const response = await fetch(`${API_BASE}${endpoint}`, fetchOptions);

  if (!response.ok) {
    // Surface the actual server-side error detail instead of just the status
    // code - that detail is the only way to diagnose a 500 from the browser.
    let detail = "";
    try {
      const body = await response.json();
      detail = body?.message || body?.details || JSON.stringify(body);
    } catch {
      detail = await response.text().catch(() => "");
    }
    console.error(`DB Gateway Exception: ${response.status}`, detail);
    throw new Error(detail || `DB Gateway Exception: ${response.status}`);
  }

  // GET DIRECTION: Return the normalized result from nrgCore
  return await response.json();
};